<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Resit Yang Dibatalkan">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Jenis Kaunter"
                            :url="service_laporan + 'lookup/lkp_kaunter_baharu'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_kaunter_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
            <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            </z-table>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        // ZenOne
        Loading
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            resit_id: null,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/resit_batal" },
                { label: "Laporan", route: "/kutipan/laporan/resit_batal" },
                {
                    label: "Senarai Resit Yang Dibatalkan",
                    route: "/kutipan/laporan/resit_batal",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "" },
            isLoading: false,
        };
    },
    methods: {
        search() {
            this.getQueryData();
            // this.$inertia.visit(
            //     window.route("kutipan.laporan.senarai_resit_batal") +
            //         "?tarikh_dari=" +
            //         this.cari.tarikh_dari +
            //         "&tarikh_hingga=" +
            //         this.cari.tarikh_hingga +
            //         "&jabatan_id=" +
            //         this.cari.jabatan_id+
            //         "&lkp_kaunter_id=" +
            //         this.cari.lkp_kaunter_id,
            //     { preserveScroll: true }
            // );
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/resit_batal/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&jabatan_id=" + this.cari.jabatan_id+
            "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,'_blank');
            },
        async getQueryData() {
            this.isLoading = true;
            const resp = await axios.get(
                this.service_laporan+'kutipan/laporan/resit_batal?user_id='+this.auth.user.id+
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&jabatan_id=" + this.cari.jabatan_id+
                    "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
                    "&page=" + this.cari.page +
                    "&per_page=" + this.cari.per_page,
            );
            this.table = resp.data.data;
            this.table.meta = resp.data.meta;
            this.isLoading = false;
        },
        },
        watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        if (this.cari.lkp_kaunter_id == "undefined") {
            this.cari.lkp_kaunter_id = "";
        }
        if(typeof this.cari.per_page === 'undefined'){
            this.cari.per_page = 10;
        } else {
            this.cari.per_page = parseInt(this.cari.per_page);
        }
        if(this.cari.page)
            this.getQueryData() 
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
